import React from "react";

function RunStatus({status}) {

    return (
        <label style={{display:'block'}}>{status['label']}</label>
    )
}

export default RunStatus